exports = module.exports = require("../../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-popover{z-index:999999999!important}.AnswerType7{display:flex;flex-direction:column;align-items:center;justify-content:center}.AnswerType7 .item{display:flex;align-items:flex-start;width:100%}.AnswerType7 .item .field+.field{margin-left:20px}.AnswerType7 .item .field{width:200px}.AnswerType7 .item .icon{margin-left:20px;width:30px;height:30px;border-radius:50%;background:#f4f2fe;margin-bottom:24px}.AnswerType7 .item .icon,.AnswerType7 .itemCreate{cursor:pointer;display:flex;align-items:center;justify-content:center}.AnswerType7 .itemCreate{width:200px;height:40px;border-radius:0;border:1px solid #17a05d;margin-bottom:10px;flex-direction:column}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Question/components/QuestionModal/components/components/Answers/components/AnswerType7/AnswerType7.scss
// module id = 4899
// module chunks = 0